import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setSelectedSuperBatch } from 'features/courseResume';
import SuperBatchSelect from 'components/SuperBatchSelect';

function ViewLectureSuperBatchSelect({ selectedSuperBatch }) {
  const dispatch = useDispatch();
  const parsedSuperBatch = selectedSuperBatch
    ? { label: selectedSuperBatch.name, value: selectedSuperBatch.id }
    : null;
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0',
    }),
  };

  const handleSelectBatch = useCallback(
    (superBatch) => {
      dispatch(
        setSelectedSuperBatch({ name: superBatch.label, id: superBatch.value })
      );
    },
    [dispatch]
  );

  return (
    <div className="m-b-s">
      <SuperBatchSelect
        styles={_styles}
        onChange={handleSelectBatch}
        value={parsedSuperBatch}
      />
    </div>
  );
}

export default ViewLectureSuperBatchSelect;
